import React from 'react';
import { Container } from 'components/layout/Container';
import { Language } from 'language/Language';
import { strings } from './strings';
import './_ProductDescription.scss';

const ProductDescription = () => {
  const language = Language();
  return (
    <>
      <Container>
        <div className='description-container'>
          <div className='description-item'>
            <h1>{strings[language].title}</h1>
            <div className='divider'>
              <div className='inner' />
            </div>
            <p>{strings[language].description}</p>
          </div>
          <img alt='360 EXPERIENCE' className='description-item__img' src='https://360ra.com/wp-content/uploads/2019/04/360RACS-Overview.jpg' />
        </div>
      </Container>
      <div className='virtualizer'>
        <h1>{strings[language].virtualizer}</h1>
        <p>{strings[language].virtualizerDescription}</p>
      </div>
    </>
  );
};

export default ProductDescription;
